import React from 'react';
import propTypes from 'prop-types';

export const Icon = ({ type, className, style }) => {
  const paths = ((type) => {
    switch(type) {
      case 'profile':
        return ["M12 0v64l20-20 20 20v-64z"]
      case 'profiles':
        return ["M16 8v56l20-20 20 20v-56zM48 0h-40v56l4-4v-48h36z"]
      case 'cross':
        return ["M55.828 13.828l-5.657-5.657-18.172 18.172-18.172-18.172-5.657 5.657 18.172 18.172-18.172 18.172 5.657 5.657 18.172-18.172 18.172 18.172 5.657-5.657-18.172-18.172z"]
      case 'pencil':
        return ["M45.779 0.221l-35.779 35.779h6v4h4v4h4v4h4v5.979l35.779-35.758c2-8-10-20-18-18z", "M24 52h-4v-4h-4v-4h-4v-4h-3.429l-8.571 24 24-8.578z"]
      case 'plus':
        return ["M62 24h-22v-22c0-1.105-0.895-2-2-2h-12c-1.105 0-2 0.895-2 2v22h-22c-1.105 0-2 0.895-2 2v12c0 1.105 0.895 2 2 2h22v22c0 1.105 0.895 2 2 2h12c1.105 0 2-0.895 2-2v-22h22c1.105 0 2-0.895 2-2v-12c0-1.105-0.895-2-2-2z"]
      case 'arrow-down':
        return ["M64 22l-8-8-24 24-24-24-8 8 32 32 32-32z"]
      case 'arrow-up':
        return ["M0 42l8 8 24-24 24 24 8-8-32-32-32 32z"]
      case 'arrow-left':
        return ["M42 64l8-8-24-24 24-24-8-8-32 32 32 32z"]
      case 'arrow-right':
        return ["M22 0l-8 8 24 24-24 24 8 8 32-32-32-32z"]
      case 'arrow-dropdown':
        return ["M14 24l18 18 18-18h-36z"]
      case 'info':
        return ["M28 19c0-1.65 1.35-3 3-3h2c1.65 0 3 1.35 3 3v2c0 1.65-1.35 3-3 3h-2c-1.65 0-3-1.35-3-3v-2z", "M40 48h-16v-4h4v-12h-4v-4h12v16h4z", "M32 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 58c-14.359 0-26-11.641-26-26s11.641-26 26-26 26 11.641 26 26-11.641 26-26 26z"]
      case 'circle':
        return ["M61,32c0,16-13,29-29,29S3,48,3,32S16,3,32,3S61,16,61,32z"]
      case 'calendar':
        return ["M20 24h8v8h-8zM32 24h8v8h-8zM44 24h8v8h-8zM8 48h8v8h-8zM20 48h8v8h-8zM32 48h8v8h-8zM20 36h8v8h-8zM32 36h8v8h-8zM44 36h8v8h-8zM8 36h8v8h-8zM52 0v4h-8v-4h-28v4h-8v-4h-8v64h60v-64h-8zM56 60h-52v-44h52v44z"]
      case 'bin':
        return ["M8 20v40c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4v-40h-44zM20 56h-4v-28h4v28zM28 56h-4v-28h4v28zM36 56h-4v-28h4v28zM44 56h-4v-28h4v28z", "M53 8h-13v-5c0-1.65-1.35-3-3-3h-14c-1.65 0-3 1.35-3 3v5h-13c-1.65 0-3 1.35-3 3v5h52v-5c0-1.65-1.35-3-3-3zM36 8h-12v-3.95h12v3.95z"]
      case 'exit':
        return ["M44 52l18-18-18-18v12h-28v12h28v12z", "M4 4h44v8h-40v44h40v8h-44c-2.209 0-4-1.791-4-4v-52c0-2.209 1.791-4 4-4z"]
      case 'world':
        return ["M32 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM22 5.841v2.159l-10 10h-4.253c3.195-5.524 8.224-9.853 14.253-12.159zM32 40l-14.293 16.080c-0.583-0.347-1.152-0.714-1.707-1.101v-12.979l-8-6v-10c0-1.105 0.896-2 2-2h6c0 0 6 8 16 10v6zM56.198 30.672c-0.989-3.327-1.844-3.651-6.198-5.131v-0c-1.489-0.467-2.891-1.289-4.071-2.469-3.905-3.905-3.905-10.237 0-14.142 0.263-0.262 0.537-0.505 0.82-0.732 7.954 4.939 13.251 13.752 13.251 23.803 0 5.184-1.411 10.039-3.867 14.203 1.030-6.656 0.65-11.989 0.065-15.531z"]
      default:
        return null;
    }
  })(type);

  return (
    // NOTE! ONLY 64x64 viewBox icons!
    <svg className={'icon ' + className} style={style} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" >
      <title>{type}</title>
      {paths.map((path, index) =>
        <path key={index} d={path} />
      )}
    </svg>
  )
}

Icon.propTypes = {
  type: propTypes.string.isRequired,
  className: propTypes.string
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js